import React from "react";
import { Box, Typography } from "@mui/material";
import DrawerFilterToggles from "../../common/DrawerFilterToggles";

interface DrawerHeaderProps {
  questionLabel?: string;
  headerTitle: string;
  datasetName?: string | null;
  activeFiltersCount: number;
  localApplyFilters: boolean;
  isTogglingFilters: boolean;
  isRefetchingData: boolean;
  onFilterToggle: () => void;
  usePreviewDateFilter?: boolean;
  onPreviewDateFilterToggle?: (enabled: boolean) => void;
}

const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  questionLabel,
  headerTitle,
  datasetName,
  activeFiltersCount,
  localApplyFilters,
  isTogglingFilters,
  isRefetchingData,
  onFilterToggle,
  usePreviewDateFilter = false,
  onPreviewDateFilterToggle,
}) => {
  // Check if dashboard date filters are present in URL
  const params = new URLSearchParams(window.location.search);
  const hasDashboardDateFilters = !!(
    params.get("df_start") && params.get("df_end")
  );

  return (
    <Box
      sx={{
        p: 2,
        borderBottom: 1,
        borderColor: "divider",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div className="flex-1">
        <Typography className="font-bold" variant="h6">
          {questionLabel || "Bar Chart Configuration"}
        </Typography>
        <Typography variant="body1">{headerTitle}</Typography>
        {datasetName && (
          <Typography variant="caption" color="text.secondary">
            Dataset: {datasetName}
          </Typography>
        )}
      </div>
      <DrawerFilterToggles
        hasDashboardDateFilters={hasDashboardDateFilters}
        usePreviewDateFilter={usePreviewDateFilter}
        onPreviewDateFilterToggle={onPreviewDateFilterToggle}
        activeFiltersCount={activeFiltersCount}
        localApplyFilters={localApplyFilters}
        onFilterToggle={onFilterToggle}
        disabled={isTogglingFilters || isRefetchingData}
      />
    </Box>
  );
};

export default DrawerHeader;
